var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-meta d-flex align-center pa-8",staticStyle:{"height":"140px"}},[_c('span',[_c('b',[_vm._v("Search error:")]),_vm._v(" "+_vm._s(_vm.queryBackendError)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }